import { useId } from 'react';

/**
 * Ko'rsatkich kartochkasidagi mitti grafik.
 *
 * `TrendChart` dan ALOHIDA va bu ataylab: u o'qlari, to'ri va yorliqlari
 * bilan O'QILADIGAN grafik, bu esa faqat SHAKLNI ko'rsatadi — "o'sdimi
 * yoki tushdimi". Bittasiga ikkala vazifani yuklash uni ikkala joyda ham
 * yomon qilardi.
 *
 * Aria-dan yashiriladi: raqamning O'ZI yonida turibdi va ekran o'quvchi
 * uchun bu shakl qo'shimcha ma'lumot bermaydi, faqat shovqin qo'shadi.
 */

const W = 96;
const H = 32;

export interface SparklineProps {
  values: readonly number[];
  /** CSS o'zgaruvchisi — mavzu almashganda chiziq o'zi moslashadi. */
  stroke: string;
}

export const Sparkline = ({ values, stroke }: SparklineProps) => {
  const id = useId();
  const max = Math.max(...values);
  const min = Math.min(...values);
  /* Hamma qiymat teng bo'lsa (masalan, hammasi nol) chiziq O'RTADAN
     o'tadi: nolga bo'linish o'rniga tekis chiziq — bu ham haqiqat. */
  const span = max - min === 0 ? 1 : max - min;

  const points = values.map((value, index) => ({
    x: (index / Math.max(1, values.length - 1)) * W,
    y: H - 2 - ((value - min) / span) * (H - 4),
  }));

  const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(' ');
  const area = `${line} L ${W} ${H} L 0 ${H} Z`;
  const last = points[points.length - 1];

  return (
    <svg
      aria-hidden
      viewBox={`0 0 ${W} ${H}`}
      className="h-8 w-24 shrink-0 overflow-visible"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id={`${id}-fill`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity="0.22" />
          <stop offset="100%" stopColor={stroke} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${id}-fill)`} />
      <path d={line} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
      {/* Oxirgi nuqta urg'ulanadi — ko'z "hozir qayerdamiz" ni shu yerdan topadi. */}
      {last === undefined ? null : <circle cx={last.x} cy={last.y} r={2} fill={stroke} />}
    </svg>
  );
};
